import * as React from 'react';
import Rating from '@mui/material/Rating';
import StarIcon from '@src/componentsNew/Icons/Icons/StarIcon';

interface IProps {
  width?: string;
  height?: string;
  starColor?: string;
}

function StarRatingIcon({ width, height, starColor }: IProps) {
  return (
    <Rating
      max={1}
      value={1}
      icon={<StarIcon fillColor={starColor ? starColor : '#212121'} width={width ? width : '14'} height={height ? height : '14'} />}
      readOnly />
  );
}

export default StarRatingIcon;
